import { useNavigate } from 'react-router-dom';
import { TicketQueue } from '../components/pwa/TicketQueue';

export function QueuePage() {
  const navigate = useNavigate();

  return <TicketQueue onOpen={(ticketId) => navigate(`/tickets/${ticketId}`)} />;
}
